// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__XWSHc","rootParamsCollapsed":"styles_rootParamsCollapsed__2OboL","rootPreviewFull":"styles_rootPreviewFull__1YJq8","loader":"styles_loader__32cK6"};